"use client";

import { defaultLocale } from "@ergon-ai/dictionaries";
import { ConsentGatedAnalyticsProvider } from "@ergon-ai/utils-web/posthog";

import { env } from "~/env";

/**
 * This app's PostHog config, on the shared consent gate. The gate itself —
 * init once, opt back in on a later yes, reset and opt out on a withdrawal —
 * lives in packages/utils-web/src/posthog.
 *
 * The locale is fixed because this site is English-only and has no i18n runtime.
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <ConsentGatedAnalyticsProvider
      apiKey={env.NEXT_PUBLIC_POSTHOG_API_KEY}
      apiHost={env.NEXT_PUBLIC_POSTHOG_API_HOST}
      debug={env.NODE_ENV === "development"}
      release={env.NEXT_PUBLIC_APP_RELEASE}
      appVersion={env.NEXT_PUBLIC_APP_VERSION}
      currentLocale={defaultLocale}
    >
      {children}
    </ConsentGatedAnalyticsProvider>
  );
}
